import config from "../config";
import UserException, { defaultErrorMessage } from "./UserException";
import NotFoundException, {
  defaultErrorMessage as notFoundDefaultErrorMessage,
} from "./NotFoundException";

const send = async (path, method, body, errorMessage) => {
  const url = `${config.adminApiOrigin}${path}`;
  const options = {
    method,
    mode: "cors",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  };
  const response = await fetch(url, options);
  let json, unauthorized, error;
  if (response.status === 401) {
    unauthorized = true;
  } else if (response.status === 403) {
    let errorJson;
    try {
      errorJson = await response.json();
    } catch {
      errorJson = {};
    }
    let title =
      (errorJson && errorJson.title) ||
      "You do not have permission to perform that action";
    error = new UserException(title);
  } else if (response.status == 404) {
    let errorJson;
    try {
      errorJson = await response.json();
    } catch {
      errorJson = {};
    }
    let title =
      (errorJson && errorJson.title) ||
      notFoundDefaultErrorMessage ||
      "The resource does not exists.";
    error = new NotFoundException(title);
    error.data = errorJson;
  } else if (!response.ok) {
    let errorJson;
    try {
      errorJson = await response.json();
      errorMessage =
        (errorJson && errorJson.title) || errorMessage || defaultErrorMessage;
    } catch {
      errorMessage = errorMessage || defaultErrorMessage;
    }
    error = new UserException(errorMessage);
    error.data = errorJson;
  } else {
    if (response.status !== 204) {
      json = await response.json();
      if (json && json.status === 401) {
        unauthorized = true;
      }
    }
  }

  if (unauthorized) {
    const path = `/Account/Login?returnUrl=${encodeURIComponent(
      document.location.pathname
    )}`;
    window.location.assign(path);
  }

  let promise;
  if (error) {
    promise = new Promise((resolve, reject) => reject(error));
  } else {
    promise = new Promise((resolve) => resolve(json));
  }

  return promise;
};

const get = (url, errMsg) => send(url, "GET", undefined, errMsg);
const post = (url, body, errMsg) => send(url, "POST", body, errMsg);
const put = (url, body, errMsg) => send(url, "PUT", body, errMsg);
const patch = (url, body, errMsg) => send(url, "PATCH", body, errMsg);
const deleteUrl = (url, errMsg) => send(url, "DELETE", undefined, errMsg);

export { send, get, post, put, patch, deleteUrl };
